// extracted by mini-css-extract-plugin
export default {"header":"style_header__0l3d1","body":"style_body__rs5s4","footer":"style_footer__9F+bn","option":"style_option__haleV"};